export default "__VITE_ASSET__98c1aed9__"